export default {
  group: { id: null, title: "" },
  date: null,
  cached: [],
  percentUploaded: 0,
  status: { status: false },
  review: "",
  isReviewReceived: false,
  selected_fb_options: "",
};
